module.exports = __webpack_public_path__ + "static/img/kefu.b9c735dd.jpg";